
































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseMailTemplate from '@/components/administration/mailTemplate/edit/EditBaseMailTemplate.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloMailTemplate } from '@/models/alo/AloMailTemplate'
import { AloMailTemplate } from '@/models/alo/AloMailTemplate'

@Component({
  name: 'EditConfig',
  components:{EditBaseMailTemplate}
})
export default class EditConfig extends Vue {
    
  private mailTemplate:AloMailTemplate = getDefaultAloMailTemplate()
  private showDate = false
  private curLang = "fr"

  get tradByLang(){    
    return toStringDictionary(this.mailTemplate.lgs,it => it.lg)
  }

  get mailSkinList(){
    return this.$store.myGetters.mailSkinList
  }

  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit(item:AloMailTemplate,lang = 'fr') {    
    this.mailTemplate = (this.$refs.baseEdit as EditBaseMailTemplate).edit(item,true)
    this.curLang = lang
  }
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }        
}
